module.exports = "/assets/images/9f9849f5936897e91614a793b641675a.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/3p-teacheradmin-assets/assets/icons/icon_activities-sadface.svg
// module id = K1ct
// module chunks = 0